// extracted by mini-css-extract-plugin
export var active = "_2p-2";
export var container = "_2p-0";
export var expired = "_2p-3";
export var hasStatus = "_2p-4";
export var statusChip = "_2p-1";